

exports.__esModule = true;
exports.$xoGenericErrorPageComponent = void 0;
var _squid = require("squid");
var _template = _interopRequireDefault(require("./template"));
require("xo-models/src/checkout/index");
require("xo-ui-components/src/generic-error/directive");
require("xo-ui-components/src/message/directive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
  tag: 'xo-generic-error-page',
  template: _template["default"],
  controller: function controller($scope, $rootScope,
  // eslint-disable-line no-shadow
  $locale, $CheckoutInputDataModel, $util, $logger, $state) {
    $scope.token = $rootScope.token;
    var terminalKey = "terminal-error-" + $scope.token,
      refreshKey = "has-seen-error-" + $scope.token;
    function renderErrorPage() {
      // prevent render flicker
      $scope.shouldRender = true;
      if ($CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
        $scope.cancelUrl = $util.param('redirect_uri');
        $scope.merchant = $locale.content.get('signup.ebay');
      }
    }
    if (!$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
      return renderErrorPage();
    }

    // is not a refresh, user landing for the first time on generic error page.
    if (!sessionStorage.getItem(refreshKey)) {
      sessionStorage.setItem(refreshKey, '1');
      return renderErrorPage();
    } else {
      // This is a refresh. Go to guest page if a refresh happens, don't show generic error page
      $logger.info('checkout_fpti', {
        user_refresh: 1
      });
      // delete the refresh key, so that next time renders the error page.
      sessionStorage.removeItem(refreshKey);
      // go guest page if a refresh happens
      $state.go('checkout.landing')["catch"](function () {
        // don't try to do this again
        sessionStorage.setItem(terminalKey, '1');
      });
    }
  }
});
angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-error/directive.js
// module id = ./pages/xo-generic-error/directive.js
// module chunks = 0